export default "__VITE_ASSET__734d620c__"